export const URL_PRIVACY_POLICY = `/condiciones-de-uso/#privacidad`
